// extracted by mini-css-extract-plugin
module.exports = {"Products":"NewArrivalPage_Products__1I4NM","Page":"NewArrivalPage_Page__2jD6t","PageAlign":"NewArrivalPage_PageAlign__3QPPy","pageout":"NewArrivalPage_pageout__3n0Nc"};